var text = {
    footer: {
        mensenlinq: function (arg) { return "<a href=\"".concat(arg, "\" target=\"_blank\">Powered by <span>Mensenlinq</span></a>"); },
    },
    search: {
        firstName: {
            label: 'Voornaam',
            placeholder: ' ',
        },
        lastName: {
            label: 'Achternaam',
            placeholder: ' ',
        },
        birthPlace: {
            label: 'Geboorteplaats',
            placeholder: ' ',
        },
        passingPlace: {
            label: 'Plaats van overlijden',
            placeholder: ' ',
        },
        birthDate: {
            label: 'Geboortedatum',
            placeholder: ' ',
        },
        passingDate: {
            label: 'Overlijdensdatum',
            placeholder: ' ',
        },
        searchbutton: {
            label: 'Zoek',
        },
        search: {
            placeholder: 'Zoek Naam, Plaats, Datum',
        },
    },
    rememberMe: {
        condolence: 'Condoleances',
        undertaker: 'Uitvaartondernemer',
        reply: function (arg) { return "Reageer op ".concat(arg); },
        condolencetext: {
            flower: 'Plaatste een bloem',
            candle: 'Brandde een kaars'
        },
        info: {
            date: 'Datum',
            time: 'Tijd',
            location: 'Locatie',
            parking: 'Parkeren',
            title: 'Praktische informatie',
            titles: {
                condolence: 'Condoleance',
                funeral: 'Uitvaart',
                stream: 'Livestream',
                lastwishes: 'Laatste wensen',
            },
        },
        about: {
            readMore: 'Lees meer',
            readLess: 'Lees minder',
            blocks: {
                readMore: 'Meer tonen',
                readLess: 'Toon minder',
            },
        },
        templates: {
            comment: {
                reactions: 'Reacties',
            },
        },
        advertisements: 'Advertenties',
        gallery: 'Gallerie',
        services: 'Diensten',
        actions: 'Plaats uw condoleance',
        over: function (arg) { return "Over ".concat(arg); },
        navigation: {
            about: function () { return function (arg) { return "Over ".concat(arg); }; },
            condolences: 'Condoleances',
            information: 'Praktische informatie',
            media: "Foto's",
            advertisements: 'Overlijdensbericht',
        },
        condolences: {
            noentries: 'No condolences found on this page',
        },
        personDetails: function (args) {
            var bornPlace = args[0], bornDate = args[1], passedPlace = args[2], passedDate = args[3];
            var result = '';
            if (bornPlace || bornDate) {
                result += 'Geboren';
                if (bornPlace) {
                    result += " in ".concat(bornPlace);
                }
                if (bornDate) {
                    result += ": ".concat(bornDate);
                }
            }
            if (passedPlace || passedDate) {
                // separator for born + passed
                if (result.length > 0) {
                    result += ' • ';
                }
                result += 'Overleden';
                if (passedPlace) {
                    result += " in ".concat(passedPlace);
                }
                if (passedDate) {
                    result += ": ".concat(passedDate);
                }
            }
            return result;
        },
    },
    actions: {
        write: {
            title: 'Schrijf condoleance',
        },
        flower: {
            title: 'Plaats een bloem',
        },
        candle: {
            title: 'Brand een kaars',
        },
        form: {
            firstName: {
                label: 'Voornaam',
                placeholder: ' ',
            },
            lastName: {
                label: 'Achternaam',
                placeholder: ' ',
            },
            email: {
                label: 'E-mail',
                labelInfo: 'Je e-mailadres wordt niet getoond op de pagina en niet ingezet voor commerciële doeleinden. We gebruiken het e-mailadres alleen als dat noodzakelijk is, bijvoorbeeld bij een probleem.',
                placeholder: ' ',
            },
            videoUrl: {
                label: 'Youtube link',
                placeholder: ' ',
            },
            message: {
                label: 'Bericht',
                placeholder: ' ',
            },
            button: {
                label: 'Plaats',
            },
        },
        submit: {
            success: {
                title: 'Condoleance geplaatst',
                message: "Uw condoleance is ter controle gestuurd naar Mensenlinq. Het kan even duren voordat uw condoleance op de website staat.",
            },
            error: {
                title: 'Uw condoleance kan helaas niet geplaatst worden',
                message: "Heeft u alle velden ingevuld? ",
            },
        },
    },
    pagination: {
        next: 'Volgende',
        previous: 'Vorige',
        first: 'Eerste',
        last: 'Laatste',
        loadMore: 'Laad meer rouwpagina\'s',
        loadMoreAllLoaded: 'Alle rouwpagina\'s zijn geladen'
    },
    variables: {
        rememberMe: {
            blocks: {
                'Burgelijke staat': 'Burgelijke staat',
                'Hobby / vrije tijd': 'Hobby / vrije tijd',
                Opleiding: 'Opleiding',
                Werk: 'Werk',
                Sport: 'Sport',
                Eten: 'Eten',
                Muziek: 'Muziek',
                Huisdier: 'Huisdier',
                Vakantie: 'Vakantie',
            },
        },
    },
    dateformats: {
        ago: 'geleden',
        seconds: function (amount) { return "".concat((amount === 1) ? 'seconde' : 'seconden'); },
        minutes: function (amount) { return "".concat((amount === 1) ? 'minuut' : 'minuten'); },
        hours: function (amount) { return "".concat((amount === 1) ? 'uur' : 'uren'); },
        days: function (amount) { return "".concat((amount === 1) ? 'dag' : 'dagen'); },
        months: function (amount) { return "".concat((amount === 1) ? 'maand' : 'maanden'); },
        years: function (amount) { return "".concat((amount === 1) ? 'jaar' : 'jaren'); },
    },
};
export default text;
